"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _actionForm = _interopRequireDefault(require("./actionForm.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Form = /*#__PURE__*/function (_React$Component) {
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Form, [].concat(args));
    _defineProperty(_this, "_clicked", function () {
      if (!_this.props.submitButtonProps.isDisabled) {
        _this.props.handleSubmit();
      }
    });
    _defineProperty(_this, "_renderField", function (field, fieldInfo) {
      switch (fieldInfo.type) {
        case 'text':
          return /*#__PURE__*/_react["default"].createElement("input", _extends({
            className: "form-control form-control-sm",
            type: "text",
            placeholder: fieldInfo.label || fieldInfo.name
          }, (0, _domOnlyProps["default"])(field)));
        case 'selectbox':
          var options = fieldInfo.options.map(function (option) {
            return /*#__PURE__*/_react["default"].createElement("option", {
              key: option.value,
              value: option.value
            }, option.label);
          });
          return /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _domOnlyProps["default"])(field), {
            className: "form-select form-select-sm",
            id: "row_actions_".concat(field.name, "_select_box")
          }), options);
        case 'password':
          return /*#__PURE__*/_react["default"].createElement("input", _extends({
            className: "form-control form-control-sm",
            type: "password",
            placeholder: fieldInfo.label || fieldInfo.name
          }, (0, _domOnlyProps["default"])(field)));
        default:
          return null;
      }
    });
    return _this;
  }
  _inherits(Form, _React$Component);
  return _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        fields = _this$props.fields,
        fieldsArray = _this$props.fieldsArray,
        submitButtonProps = _this$props.submitButtonProps,
        submitting = _this$props.submitting;
      var rows = fieldsArray.map(function (fieldInfo) {
        var field = fields[fieldInfo.name];
        return /*#__PURE__*/_react["default"].createElement("span", {
          key: fieldInfo.name
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: 'mb-3 ' + _actionForm["default"].wrapper + ' ' + (field.touched && field.error ? 'is-invalid' : '')
        }, _this2._renderField(field, fieldInfo), field.touched && field.error && /*#__PURE__*/_react["default"].createElement("div", {
          className: _actionForm["default"].error
        }, field.error)), ' ');
      });
      var isLoading = submitting || submitButtonProps.isLoading;
      return /*#__PURE__*/_react["default"].createElement("span", null, rows, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], _extends({}, submitButtonProps, {
        isLoading: isLoading,
        className: "btn btn-primary btn-sm",
        onClick: this._clicked,
        isConfirm: false
      })));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Form, "propTypes", {
  fields: _propTypes["default"].object.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  submitting: _propTypes["default"].bool.isRequired,
  fieldsArray: _propTypes["default"].array.isRequired,
  submitButtonProps: _propTypes["default"].object.isRequired
});
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: 'actionForm'
})(Form);